import { signal } from '@preact/signals-react';

const configData = signal({
	exhID: '', // 展覽ID
	Timeout: null, // 重新產生UUID的秒數
	recordAPI: '', // 單向紀錄用API
	recordUser: '', // 單向紀錄用API呼叫用帳號
	recordPassword: '', // 單向紀錄用API呼叫用密碼
	recommandAPI: '', // 推薦用API
	recommendSource: '', // local or remote
	accounts: [], // 帳號
	token: '', // token
	userAPI: '', // 使用者資訊API
});

fetch('./config.json')
	.then(response => response.json())
	.then(config => {
		configData.value = {
			...configData.value,
			...config,
		};
	})
	.catch(error => console.error(error));

export default configData;